import badge from "./index.vue";
export default badge;
